import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';
import { Booking } from '@/models/booking.model';
import { cloneDeep } from 'lodash';

interface LoadingState {
  singleBooking: Booking | null;
  singleBookingIncludedArray: any[];
}

export const defaultSingleBookingState: LoadingState = {
  singleBooking: null,
  singleBookingIncludedArray: []
};

const state: LoadingState = cloneDeep(defaultSingleBookingState);

const mutations: MutationTree<LoadingState> = {
  ADD_SINGLE_CONTACT(returnedState: LoadingState, payload: { booking: Booking; includedArray: any[] }): void {
    returnedState.singleBooking = payload.booking;
    returnedState.singleBookingIncludedArray = payload.includedArray;
  },
  REMOVE_SINGLE_CONTACT(returnedState: LoadingState): void {
    returnedState.singleBooking = null;
    returnedState.singleBookingIncludedArray = [];
  }
};

const actions: ActionTree<LoadingState, {}> = {
  addContact: (
    { commit }: ActionContext<LoadingState, {}>,
    payload: { booking: Booking; includedArray: any[] }
  ): void => {
    commit('ADD_SINGLE_CONTACT', payload);
  },
  removeContact: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('REMOVE_SINGLE_CONTACT');
  }
};

const getters: GetterTree<LoadingState, {}> = {
  singleBooking: (returnedState: LoadingState): Booking | null => {
    return returnedState.singleBooking;
  },

  singleBookingIncludedArray: (returnedState: LoadingState): any[] => {
    return returnedState.singleBookingIncludedArray;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
